import pages from '../namespaces/pages/ko';
import components from '../namespaces/components/ko';
import common from '../namespaces/common/ko';
import errors from '../namespaces/errors/ko';
import validation from '../namespaces/validation/ko';
import gameDetail from '../namespaces/gameDetail/ko';

export default {
  common,
  pages,
  components,
  errors,
  validation,
  gameDetail
}; 